<template>
	<div class="w-full">
		<div class="mb-3">
			<span class="mb-0 font-medium text-gray-650">Year</span>
		</div>

		<div v-if="isDirty" class="m-0 space-y-3 p-0">
			<FilterSelectbox
				v-model="yearFrom"
				mode="single"
				:options="yearFromOptions"
				value-prop="value"
				label="label"
				placeholder="From"
				:searchable="true"
				:groups="false"
				:close-on-select="true"
				:hide-selected="false"
				:show-apply-and-clear="false"
				:can-clear="false"
				:can-deselect="false"
				@change="onChange($event, 'yearFrom')"
			/>

			<FilterSelectbox
				v-model="yearTo"
				mode="single"
				:options="yearToOptions"
				value-prop="value"
				label="label"
				placeholder="To"
				:searchable="true"
				:groups="false"
				:close-on-select="true"
				:hide-selected="false"
				:show-apply-and-clear="false"
				:can-clear="false"
				:can-deselect="false"
				@change="onChange($event, 'yearTo')"
			/>
		</div>

		<div v-if="showContentLoader" class="flex flex-col gap-2">
			<ContentLoader width="w-full" height="h-[35px]" />
		</div>
	</div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import FilterSelectbox from '@/components/selectboxes/FilterSelectbox.vue'
import { useProductCatalog } from '@/stores/product-catalog'
import ContentLoader from '@/components/ContentLoader.vue'

const productCatalog = useProductCatalog()

const yearFrom = ref(
	productCatalog.filters.yearFrom ? productCatalog.filters.yearFrom : 'all'
)
const yearTo = ref(
	productCatalog.filters.yearTo ? productCatalog.filters.yearTo : 'all'
)

const yearFromOptionsOriginal = computed(() => productCatalog.facets.yearFrom)

const yearToOptionsOriginal = computed(() => productCatalog.facets.yearTo)

const yearFromOptions = computed(() => {
	const options = []
	yearFromOptionsOriginal.value.forEach((option) => {
		if (
			yearTo.value &&
			option.value !== 'all' &&
			option.value >= yearTo.value
		) {
			return
		}

		options.push(option)
	})

	return options
})

const yearToOptions = computed(() => {
	const options = []
	yearToOptionsOriginal.value.forEach((option) => {
		if (
			yearFrom.value &&
			option.value !== 'all' &&
			option.value <= yearFrom.value
		) {
			return
		}

		options.push(option)
	})

	return options
})

const isDirty = computed(() => productCatalog.isDirty)

const showContentLoader = computed(() => !isDirty.value)

watch(
	() => productCatalog.filters.yearFrom,
	(newValue) => {
		yearFrom.value = newValue === null || newValue === '' ? 'all' : newValue
	}
)

watch(
	() => productCatalog.filters.yearTo,
	(newValue) => {
		yearTo.value = newValue === null || newValue === '' ? 'all' : newValue
	}
)

const onChange = (filterValue, filterKey) => {
	let updateFilterValue = filterValue

	// handle when 'all' is selected
	if (updateFilterValue === 'all') {
		updateFilterValue = null
	}

	productCatalog.updateFilter({
		filterKey,
		filterValue: updateFilterValue,
	})
}
</script>
